<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader title="Non-Cannabis Sales by Employee" :links="[
        { name: 'home', label: 'Home' },
        { name: 'reports', label: 'Reports' },
        { name: 'salesReport', label: 'Sales' },
        {
          name: 'salesRecapTransactionsEmployee',
          label: 'Non-Cannabis Sales by Employee',
        },
      ]" @export="exportToCsv" :disableExport="!reportData" />
      <br class="no-print" />
      <ReportFilter class="no-print" :filterByTime="true" @submit-filter="performGetReport"
        :isLoading="salesTransactions" :filterBySaleType="true" />
      <div class="report-container">
        <!-- This could be a component -->
        <div class="report-body" v-if="reportData">
          <table id="table-report">
            <thead>
              <tr class="report-body__row report-body__row--header"></tr>
              <tr>
                <td colspan="5">Non-Cannabis Sales by Employee</td>
              </tr>
              <tr>
                <td colspan="5">{{ reportData.total.datePeriod }}</td>
              </tr>
              <tr>
                <td> </td>
              </tr>
              <tr>
                <td> </td>
              </tr>
              <tr>
                <th align="left">Employee</th>
                <th align="left">Supplier</th>
                <th align="left">Group</th>
                <th align="left">Product</th>
                <th align="right">Sale Price</th>
                <th align="right">Quantity</th>
                <th align="right">Sub Total</th>
                <th align="right">Discount</th>
                <th align="right">Line Total</th>
                <th align="right">Tax</th>
                <th align="right">Delivery</th>
                <th align="right">Total</th>
              </tr>
            </thead>

            <tbody>
              <tr class="report-body__row"></tr>
              <tr v-for="(data, index) of formattedData" :key="index" :class="{ total2: data.isTotal }">
                <td v-if="!data.isTotal">{{ data.employee }}</td>
                <td v-else>Totals</td>
                <td>{{ data.supplier }}</td>
                <td>{{ data.group }}</td>
                <td>{{ data.product }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.price) }}</td>
                <td align="center">{{ data.quantity }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.subTotal) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.discount) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.lineTotal) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.tax) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.freight) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.total) }}</td>
              </tr>
            </tbody>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
            <tr>
              <td colspan="5" align="left">Grand Totals</td>
              <td align="center">{{ reportData.total.quantity }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.subTotal) }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.discount) }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.lineTotal) }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.tax) }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.freight) }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.total) }}</td>
            </tr>
            <tr class="skip-export"></tr>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>

          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import ReportHelper from "@/lib/report/index.js";
import { mapActions, mapGetters } from "vuex";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";

export default {
  data() {
    return {
      reportData: undefined,
      Utilities,
      reportType: undefined,
      selectedPeriod: undefined,
      selectedReportFor: undefined,
      selectedReportSaleType: undefined,
      filterText: undefined,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.setPageTitle("Non-Cannabis Sales by Employee");
  },
  mounted: function () {
    const today = new Date();
    this.selectedPeriod = {
      from: new Date(new Date().setDate(today.getDate() - 7)),
      to: today,
    };
  },
  computed: {
    ...mapGetters({
      loadingStatus: "reports/loadingStatus",
      salesTransactions: "reports/salesTransactions",
    }),
    formattedData() {
      const data = this.reportData;
      let rows = []
      for (let [name, nameValue] of Object.entries(data.records)) {
        for (let [product, item] of Object.entries(nameValue.items)) {
          rows.push(item)
        }
        rows.push({ ...nameValue.total, isTotal: true })
      }

      return rows;
    }
  },
  methods: {
    ...mapActions({
      getSalesTransactions: "reports/getSalesTransactions",
    }),
    performGetReport(filter) {
      let reportType = "salesRecapTransactionsDetailedEmployee";
      this.getSalesTransactions({
        reportType,
        ...filter,
        positiveCallback: (data) => {
          this.reportData = data;
        },
      });
    },
    exportToCsv() {
      var table = document.getElementById("table-report");
      ReportHelper.exportToExcel(table, "nonCannabisSalesByEmployee.csv");
    },
  },
};
</script>

<style lang="scss">
@import "./_salesRecapTransactionsEmployee.scss";
